
import {
    AdminUsers,
    AdminUsersList,
    AdminUsersDetail,
} from '@/screens'

export default meta => [{
    path: 'users',
    name: 'AdminUsers',
    component: AdminUsers,
    redirect: { name: 'AdminUsersList' },
    meta,
    children: [
        {
            path: 'list',
            name: 'AdminUsersList',
            component: AdminUsersList,
            meta,
        },
        {
            path: 'detail/:id',
            name: 'AdminUsersDetail',
            component: AdminUsersDetail,
            meta,
        },
    ],
}]
